import React, { Component } from 'react';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class GridActionContent extends Component {
    render() {
        const { t, styleWidth, styleHight, gridObjData, editButtonShow, deleteButtonShow, checkListButtonShow, archivedButtonShow, leaveviewButtonShow, resultButtonShow, cancelButtonShow, cancelButtonLabel, viewtButtonShow, viewHeaderDetailsShow,
            viewRequestParamsShow, addRemoveContacts, viewDetailsShow, integrationMappingShow, viewScheduleShow, controlPannelButtonShow, showSendButton, showAnalyticsButton, webhookSettingModal, webhookSettingButtonShow, isWebhooksEditableShow, addContactShow, assignContactShow } = this.props; // for control pannel
        return (
            <div className="actionableInnerBox" style={{ position: 'absolute', left: `${styleWidth}`, top: `${styleHight}` }} ref={this.props.codeOutsideClickRef}>
                <div className="actionableBtnCenter">
                    {leaveviewButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.leaveview.bind(this, gridObjData)}><span><i className="fa fa-calendar-check-o" ></i></span> {t('leaveview')}</button>
                    </div> : null}
                    {editButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={() => { this.props.modefier(gridObjData, "") }}><span><i className="fa fa-pencil" ></i></span> {t('edit')}</button>
                    </div> : null}
                    {deleteButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.delete.bind(this, gridObjData)}><span><i className="fa fa-trash-o"></i></span> {t('delete')}</button>
                    </div> : null}
                    {isWebhooksEditableShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={() => { this.props.modefierWebhooks(gridObjData, "") }}><span><i className="fa fa-pencil" ></i></span> {'Edit Webhooks'}</button>
                    </div> : null}
                    {checkListButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.checklist.bind(this, gridObjData.data)}><span><img src={require('../../Utility/Public/images/checklist.png')} /></span> checklist</button>
                    </div> : null}
                    {/* ======== for control pannel ======= */}
                    {controlPannelButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.controlPannelModal.bind(this, gridObjData.data)}><span><img src={require('../../Utility/Public/images/control_panel.png')} /></span> Control Panel Settings</button>
                    </div> : null}
                    {/* ======== end for control pannel ======== */}
                    {/* ======== for webhooh setting pannel ======= */}
                    {webhookSettingButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.webhookSettingModal.bind(this, gridObjData.data)}><span><img src={require('../../Utility/Public/images/webhook_settings.png')} /></span> Webhook Settings</button>
                    </div> : null}
                    {/* ======== end for webhook setting pannel ======== */}
                    {archivedButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.archived.bind(this, gridObjData)}><span><i className="fa fa-archive"></i></span> {t('archivedMembers')}</button>
                    </div> : null}
                    {cancelButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.cancel.bind(this, gridObjData)}><span><i className={cancelButtonLabel == "Cancel" ? "fa fa-times" : "fa fa-calendar"}></i></span> {cancelButtonLabel}</button>
                    </div> : null}
                    {resultButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.result.bind(this, gridObjData)}><span><i className="fa fa-file-text"></i></span> {t('result')}</button>
                    </div> : null}
                    {viewtButtonShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.view.bind(this, gridObjData)}><span><img src={require('../../Utility/Public/images/json-file.png')} /></span> View Template</button>
                    </div> : null}
                    {viewHeaderDetailsShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.viewHeaderDetailsJson.bind(this, gridObjData)}><span><img src={require('../../Utility/Public/images/json-file.png')} /></span> View Header Details JSON</button>
                    </div> : null}
                    {viewRequestParamsShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.viewRequestParamsJson.bind(this, gridObjData)}><span><img src={require('../../Utility/Public/images/json-file.png')} /></span> View Request Body Params JSON</button>
                    </div> : null}
                    {addRemoveContacts ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.addRemoveContactsFn.bind(this, gridObjData)}><span></span> Add/Remove Contacts</button>
                    </div> : null}
                    {viewDetailsShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.viewDetails.bind(this, gridObjData)}><span><img src={require('../../Utility/Public/images/audit.png')} /></span> View Details</button>
                    </div> : null}
                    {integrationMappingShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.integrationMapping.bind(this, gridObjData)}><span><img src={require('../../Utility/Public/images/diagram.png')} /></span> Integration Mapping</button>
                    </div> : null}
                    {viewScheduleShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.viewSchedule.bind(this, gridObjData)}><span><img src={require('../../Utility/Public/images/calendar.png')} /></span> View Schedule</button>
                    </div> : null}
                    {showSendButton ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.sendTemplateMessage.bind(this, gridObjData)}><span><i className="fa fa-paper-plane" aria-hidden="true"></i>
                        </span>Send</button>
                    </div> : null}
                    {showAnalyticsButton ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.showAnalyticsFn.bind(this, gridObjData)}><span><i className="fa fa-paper-plane" aria-hidden="true"></i>
                        </span>Analytics</button>
                    </div> : null}
                    {addContactShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.addContactfn.bind(this, gridObjData)}><span><i className="fa fa-plus" aria-hidden="true"></i>
                        </span>Add/Remove Contact</button>
                    </div> : null}
                    {assignContactShow ? <div className="actionableRow">
                        <button className="actionableIcon" onClick={this.props.assignContactfn.bind(this, gridObjData)}><span><i className="fa fa-plus" aria-hidden="true"></i>
                        </span>Assign Primary Contact</button>
                    </div> : null}
                </div>
            </div>
        );
    }
}
GridActionContent.defaultProps = {
    editButtonShow: true,
    deleteButtonShow: true,
    checkListButtonShow: false,
    archivedButtonShow: true,
    leaveviewButtonShow: false,
    resultButtonShow: false,
    cancelButtonShow: false,
    cancelButtonLabel: "Cancel",
    viewtButtonShow: false,
    addRemoveContacts: false,
    viewDetailsShow: false,
    integrationMappingShow: false,
    viewScheduleShow: false,
    showSendButton: false,
    showAnalyticsButton: false,
    isWebhooksEditableShow: false,
    addContactShow: false,
    assignContactShow: false,
}
const mapStateToProps = (globalState) => {
    return {

    };
}

export default withRouter(connect(mapStateToProps, {})
    (withTranslation()(GridActionContent)));